module.exports = __webpack_public_path__ + "static/media/bonarka03.845987de.jpg";